<template>
  <Fragment>
    <div class="relative bg-[#05070c] px-15 w-full h-full text-white">
      <!-- <div class="h-full justify-space-between items-center hidden sm:flex">
        <div class="banner-content z-2 flex justify-center w-full h-full">
          <div class="button-section w-full">
            <div>
              <el-button
                class="button-disabled uppercase blue_button bg-lightBlueG0 focus:bg-lightBlueG0 focus:text-black h-[26px] p-0 mt-2 md:mb-1 text-2xs text-black flex justify-center items-center"
                type="secondary"
                >ثبت نام
              </el-button>
              <div class="md:block md:mb-2 uppercase text-[7px]">شرایط و ضوابط اعمال می شود.</div>
            </div>
          </div>
          <div class="title-section w-full">
            <div>
              <img
                class="hidden md:block w-[94px] h-[21px] object-scale-down"
                src="@/assets/images/vt/logo_login_v2.png"
              />
              <div class="uppercase text-lightBlueG0 md:text-xl font-bold my-0.5">هدیه نوروزی VTMarkets</div>
              <div class="uppercase to-white md:text-sm">نوروز باستانی را با VTMarkets چشن بگیرید</div>
              <div class="uppercase to-white md:text-sm">واریز کنید. ترید کنید. برنده شوید.</div>
            </div>
          </div>
        </div>
      </div>
      <img src="@/assets/images/banner/norouziGift/bg_no_text.png" class="banner hidden sm:block" /> -->
      <img src="@/assets/images/banner/norouziGift/bg_pc.png" class="banner hidden sm:block" />
      <img src="@/assets/images/banner/norouziGift/bg_mobile.png" class="banner sm:hidden" />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'BannerItem',
  components: { Fragment },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    }
  },
  methods: {
    goToLink() {
      const link =
        this.lang === 'ar'
          ? 'https://www.vtmarkets.com/ar/trade-and-win/?utm_source=org&utm_medium=nurturing&utm_campaign=mena_Trade&Win&utm_content=AR_ClientPortal_banner&utm_text=version1&rt=organic_na_others'
          : 'https://www.vtmarkets.com/ar/trade-and-win-en/?utm_source=org&utm_medium=nurturing&utm_campaign=mena_Trade&Win&utm_content=EN_ClientPortal_banner&utm_text=version1&rt=organic_na_others';
      window.open(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

[dir='rtl'] {
  .banner-content {
    flex-direction: row-reverse;
  }

  .title-section {
    justify-content: flex-start;
  }

  .button-section {
    justify-content: flex-end;
  }
}

.title-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.button-section {
  display: flex;
  align-items: flex-end;
}

.button-disabled {
  min-width: 75px;
  pointer-events: none;
}
</style>
